import moment from "moment";
import constants from "../constants";

const timeoutCheck = (epochTime) => {
	const AuthStr = "Bearer ".concat(window.localStorage.getItem("user_token"));
	try {
		axios({
			method: "POST",
			url: constants.logout,
			headers: {
				Authorization: `Bearer ${window.localStorage.getItem("user_token")}`,
			},
		});
	} catch (e) {
		console.log(e);
	}
	fetch(constants.graphql, {
		method: "POST",
		headers: {
			"Content-Type": "application/json",
			Accept: "application/json",
			Authorization: AuthStr,
		},
		body: JSON.stringify({
			query: `mutation{updateUser(input:{where:{id:"${window.localStorage.getItem(
				"id",
			)}"},data:{last_login:"${moment(epochTime).toISOString()}"}}){user{id}}}`,
		}),
	})
		.then((response) => {
			window.localStorage.clear();
			location.reload(true);
		})
		.catch((error) => {
			console.log(error);
			window.localStorage.clear();
			location.reload(true);
		});
};

export default timeoutCheck;
